/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import jwt_decode from "jwt-decode";
import authActions from '../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../hooks/useAuthorizedEpApps';
import config from '../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../constants';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import FileUploadComp from '../../components/FileUploadComp/FileUploadComp';
import TableView from '../../components/FileUploadComp/TableView/TableView';
import TemploadUpload from '../../components/FileUploadComp/TemplateUpload/TemplateUpload';
import TabSwitcher from '../../components/FileUploadComp/TabSwitcher/TabSwitcher';
import FileuploadLogsComp from '../../components/FileUploadComp/FileUploadLogs/FileuploadLogsComp';
import styles from './FileUpload.module.css';
import { saveLogToBackend } from '../../api';

const { API_BASE_URL } = config;

const FileUpload = ({
  isAuthenticated,
  authPolicies,
  currentUserId,
}) => {

  const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
  const { showLoading } = usePopupManager();

  useEffect(() => {
    if (
      authorizedApps.length &&
      !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
    ) {
      showLoading();
      window.location.replace(config.HOME_UI_BASE_URL);
    }
  }, [authorizedApps, currentUserId]);

  const [selectedTab, setSelectedTab] = useState('File Upload');
  const [canSeeReviewTab, setcanSeeReviewTab] = useState(false);
  const [canSeeReviewTabLogs, setcanSeeReviewTabLogs] = useState(false);

  const logData = {
    username: localStorage.getItem("preferred_username") || "anonymous",
    page: window.location.pathname,
    method: "PAGE_VISIT",
    url: window.location.href,
    status: "SUCCESS",
    duration: 0,
    timestamp: new Date().toISOString(),
  };

  useEffect(() => {
    const getUserRoles = async () => {
      try {
        const headerss = new Headers();
        headerss.append("Content-Type", "application/json");
        const url = `${API_BASE_URL}/api/token/auth`;
        const TokenData = keycloak.token;
        const decoded = jwt_decode(TokenData);
        const userName = decoded.preferred_username;
        const response = await fetch(url, {
          method: "POST",
          headers: headerss,
          body: JSON.stringify({ username: userName }),
        });
        const data = await response.json();
        const UserData = Array.isArray(data.SuperUserRole) ? data.SuperUserRole : [];
        if (UserData.includes('TMLTempUploadUser')) {
          setcanSeeReviewTab(true);
        } 
        if (UserData.includes('TMLFileUploadLogs')) {
          setcanSeeReviewTabLogs(true);
        } 
        // else {
        //   setcanSeeReviewTab(false);
        // }
      } catch (err) {
        console.error(err);
      }
    };
    saveLogToBackend(logData);
    setTimeout(() => {
      getUserRoles();
    }, 500);
  }, []);

  const availableTabs = ['File Upload', 'Table View'];
  if (canSeeReviewTab) {
    availableTabs.push('Template Upload');
  }
  if (canSeeReviewTabLogs) {
    availableTabs.push('File upload logs');
  }

  return (
    <div className={styles.container}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <TabSwitcher
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          tabs={availableTabs}
        />
        <button
          className="btn btn-outline-info"
          onClick={() => {
            const link = document.createElement("a");
            link.href = "/File_Upload_Utility_User_Guide_Document_TMGSL.pdf";
            link.download = "File_Upload_Utility_User_Guide_Document_TMGSL.pdf";
            link.click();
          }}
        >
          Help / User Manual
        </button>
      </div>

      {selectedTab === 'File Upload' ? (
        <FileUploadComp />
      ) : selectedTab === 'Table View' ? (
        <TableView />
      ) : selectedTab === 'Template Upload' && canSeeReviewTab ? (
        <TemploadUpload />
      ) : selectedTab === 'File upload logs' && canSeeReviewTab ? (
        <FileuploadLogsComp />
      ) : null}
    </div>
  )
}

FileUpload.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authPolicies: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default connect(({ auth, userProfile }) => ({
  isAuthenticated: auth.isAuthenticated,
  authPolicies: auth.authPolicies,
  currentUserId: userProfile.userId,
  setAuthToken: authActions.setAuthToken,
}))(FileUpload);
